import React from "react";
import ReactDOM from "react-dom";
import "./css/style.css";
import RoutesEntryPoint from "./App";

ReactDOM.render(<RoutesEntryPoint />, document.getElementById("root"));
